import * as React from "react";
const SvgBox = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: .5,
	y: .5,
	width: 11,
	height: 11,
	fill: "#F2F3F7",
	stroke: "#969FA8"
}));
export default SvgBox;
